module.exports = __webpack_public_path__ + "assets/4f897e9b079fda1934cbd1858373007d.mp3";